import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CentralOfficeComponent } from './central-office/central-office.component';
import { OpticalCableComponent } from './optical-cable/optical-cable.component';
import { AppliedFormComponent } from './optical-closure-form/applied-form/applied-form.component';
import { OpticalClosureFormComponent } from './optical-closure-form/optical-closure-form.component';
import { SpecificationFormComponent } from './optical-closure-form/specification-form/specification-form.component';
import { SpecificationPainelComponent } from './optical-closure-form/specification-painel/specification-painel.component';
import { SimulationArchitectureComponent } from './simulation-architecture.component';
import { UndergroundComponent } from './underground/underground.component';

@NgModule({
  declarations: [
    SimulationArchitectureComponent,
    CentralOfficeComponent,
    OpticalCableComponent,
    OpticalClosureFormComponent,
    SpecificationFormComponent,
    SpecificationPainelComponent,
    UndergroundComponent,
    AppliedFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class SimulationArchitectureModule { }
